<template>
    <div class="wrapper">
        <div class="main-panel">
            <div class="main-content">
                <div class="content-wrapper">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="card-block">
                                            <h2>Exam registry</h2>
                                            <table class="table table-responsive-sm">
                                                <thead>
                                                    <th>
                                                        Exam
                                                    </th>
                                                    <th>
                                                        Patient
                                                    </th>
                                                    <th>
                                                        Date
                                                    </th>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="exam in exams" :key="exam._id">
                                                        <td>
                                                            {{ exam.type.name[$i18n.locale] ? exam.type.name[$i18n.locale] : exam.type.name['en'] }}
                                                        </td>
                                                        <td>
                                                            {{ exam.patientId.surname }} {{ exam.patientId.name }}
                                                        </td>
                                                        <td>
                                                            {{ formatDate(exam.date) }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MedicalExamsService from '@/services/medicalExams'
import moment from 'moment'

export default {
    data() {
        return {
            exams: []
        }
    },
    methods: {
        formatDate(d) {
            return moment(new Date(d)).format("YYYY-MM-DD")
        }
    },
    mounted: async function() {
        let exams = await MedicalExamsService.allWithPatient()
        if (exams) {
            this.exams = exams.data
        }
    }
 }
</script>

